// SettingsTab — Hesap ayarlari (email, password)
import { Mail, Save, User } from 'lucide-react'
import { useEffect, useState } from 'react'
import { API_URL, apiFetch } from '../../config/api'
import { useAuth } from '../../contexts/AuthContext'

export default function SettingsTab() {
  const { user, reloadUser } = useAuth()
  const [displayName, setDisplayName] = useState('')
  const [email, setEmail] = useState('')
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [saving, setSaving] = useState(false)
  const [msg, setMsg] = useState<{ type: 'ok' | 'err'; text: string } | null>(null)

  useEffect(() => {
    if (user) {
      setDisplayName(user.display_name || '')
      setEmail(user.email || '')
    }
  }, [user])

  const inputStyle: React.CSSProperties = {
    width: '100%', padding: '10px 14px', borderRadius: 8,
    background: 'var(--body-bg)', border: '1px solid var(--border-color)',
    color: 'var(--text-primary)', fontSize: 14, outline: 'none'
  }
  const labelStyle: React.CSSProperties = { fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 4, display: 'block' }
  const cardStyle: React.CSSProperties = { padding: 20, borderRadius: 12, background: 'var(--body-bg)', border: '1px solid var(--border-color)' }

  const handleProfileSave = async () => {
    setSaving(true); setMsg(null)
    try {
      const r = await apiFetch(`${API_URL}/api/profile/update`, { method: 'PUT', body: JSON.stringify({ display_name: displayName }) })
      if (r.ok) { setMsg({ type: 'ok', text: 'Profile updated' }); await reloadUser() }
      else { const d = await r.json() as { detail?: string }; setMsg({ type: 'err', text: d.detail || 'Failed' }) }
    } catch { setMsg({ type: 'err', text: 'Network error' }) }
    setSaving(false)
  }

  const handlePasswordChange = async () => {
    if (newPassword !== confirmPassword) { setMsg({ type: 'err', text: 'Passwords do not match' }); return }
    if (newPassword.length < 6) { setMsg({ type: 'err', text: 'Min 6 characters' }); return }
    setSaving(true); setMsg(null)
    try {
      const r = await apiFetch(`${API_URL}/api/profile/update`, { method: 'PUT', body: JSON.stringify({ old_password: oldPassword, new_password: newPassword }) })
      if (r.ok) { setMsg({ type: 'ok', text: 'Password changed' }); setOldPassword(''); setNewPassword(''); setConfirmPassword('') }
      else { const d = await r.json() as { detail?: string }; setMsg({ type: 'err', text: d.detail || 'Failed' }) }
    } catch { setMsg({ type: 'err', text: 'Network error' }) }
    setSaving(false)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      {msg && <div style={{ padding: '8px 12px', borderRadius: 8, background: msg.type === 'ok' ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)', color: msg.type === 'ok' ? '#10b981' : '#ef4444', fontSize: 13 }}>{msg.text}</div>}

      {/* Profile info */}
      <div style={cardStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
          <User size={15} color="#6366f1" />
          <span style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-primary)' }}>Account Information</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div>
            <label style={labelStyle}>Display Name</label>
            <input value={displayName} onChange={e => setDisplayName(e.target.value)} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Email</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <Mail size={14} color="var(--text-secondary)" />
              <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{email}</span>
            </div>
          </div>
          <button onClick={() => { void handleProfileSave() }} disabled={saving} style={{ alignSelf: 'flex-start', display: 'flex', alignItems: 'center', gap: 5, padding: '8px 16px', borderRadius: 8, background: '#667eea', border: 'none', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            <Save size={14} /> Save
          </button>
        </div>
      </div>

      {/* Password */}
      <div style={cardStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-primary)' }}>Change Password</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div>
            <label style={labelStyle}>Current Password</label>
            <input type="password" value={oldPassword} onChange={e => setOldPassword(e.target.value)} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>New Password</label>
            <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Confirm New Password</label>
            <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} style={inputStyle} />
          </div>
          <button onClick={() => { void handlePasswordChange() }} disabled={saving} style={{ alignSelf: 'flex-start', padding: '8px 16px', borderRadius: 8, background: 'var(--card-bg)', border: '1px solid var(--border-color)', color: 'var(--text-primary)', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            Change Password
          </button>
        </div>
      </div>
    </div>
  )
}
